import './Homepage.css';

import inventory from "../../lib/inventory.json";
import stores from "../../lib/stores.json";

import ButtonLink from '../../components/ButtonLink';
import ColoredLink from '../../components/ColoredLink';
import FullPageMarquee from '../../components/FullPageMarquee';
import Card from '../../components/Card';
import Address from '../../components/Address';

import WordDesign from '../../assets/dynamic/word-designs';
import WordAbout from '../../assets/dynamic/word-about';
import WordPurchase from '../../assets/dynamic/word-purchase';
import AboutText from '../../assets/about-text.svg';

import { pick } from '../../lib/utilities';

function Homepage({ color }) {
  const designs = pick(3, Object.keys(inventory));

  return (
    <div className={`App bg bg-image-${color}`}>
      <div className="about section">
        <h2 id="about" className="sr-only">About</h2>
        <div className="section-header">
          <FullPageMarquee LoopComponent={() => <WordAbout color={color} />} />
        </div>
        <div className="about-container">
          <div className="about-left center">
            <img src={AboutText} className="about-left-text-image" alt="Step into the world of timeless elegance with Pafiume Jewelry, an emerging artisanal brand" />
            <div className="about-left-mask bg bg-color-grey bg-image-white"></div>
          </div>
          <div className={`about-right bg bg-color-${color} bg-image-white`}>
            <p>
              Step into the world of timeless elegance with Pafiume Jewelry, an emerging artisanal brand dedicated to crafting exquisite necklaces, bracelets, and earrings that showcase the beauty of pearls and gemstones. At Pafiume, each piece is meticulously designed to embody sophistication and individuality, whether adorned with lustrous pearls or vibrant gemstones. Our commitment to quality and craftsmanship ensures that each creation is a testament to the enduring allure of nature's treasures. From classic pearl strands to contemporary gemstone masterpieces, Pafiume Jewelry invites you to indulge in the perfect blend of tradition and modernity, allowing you to express your unique style with every carefully curated piece. Elevate your elegance with Pafiume, where the art of jewelry-making meets the everlasting beauty of pearls and gemstones.
            </p>
          </div>
        </div>
      </div>
      {/* TODO: add spotlight section */}
      <div className="designs section">
        <h2 id="designs" className="sr-only">Designs</h2>
        <div className="section-header">
          <FullPageMarquee LoopComponent={() => <WordDesign color={color} />} />
        </div>
        <div className="inventory-list">
          <div className="container">
            <div className="row">
              {
                designs.map((name) => {
                  const collection = inventory[name];
                  const item = pick(1, collection)[0];
                  return (
                    <div className="col-4 center-children" key={`${item.name}-${item.category}`}>
                      <Card item={item} color={color} />
                    </div>
                  );
                })
              }
            </div>
            <div className="row center-children">
              <div className="col-5">
              <ButtonLink color={color} to="/products">
                View all products
              </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="purchase section">
        <h2 id="purchase" className="sr-only">Purchase</h2>
        <div className="section-header">
          <FullPageMarquee LoopComponent={() => <WordPurchase color={color} />} />
        </div>
        <div className="purchase-container container">
          <div className="row">
            {/* TODO: add Etsy link if I decide to make one */}
            <p>
              Discover the allure of Pafiume Jewelry at select stores throughout the enchanting city of New Orleans, where our exquisite pieces find their home in carefully curated spaces. Additionally, for those seeking a more personalized experience, Pafiume Jewelry occasionally graces the vibrant landscape of <ColoredLink color={color} to="markets">New Orleans' art markets</ColoredLink>, providing an opportunity to explore our handcrafted treasures amidst the vibrant atmosphere of local artistry. Stock may differ based on location and availability.
            </p>
            <div className="row">
              {
                stores.map((store) => (
                  <div className="col-3" key={store.name + store.zip}>
                    <Address color={color} store={store} />
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Homepage;
